import { render } from "./PersonCard.vue?vue&type=template&id=4955ebb6&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"

import "./PersonCard.vue?vue&type=style&index=0&id=4955ebb6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4955ebb6"]])

export default __exports__